function challengeText(task) {
  return `${task?.type || ""} ${task?.title || ""} ${task?.description || ""}`.toLowerCase();
}

export function challengeDestination(task) {
  const text = challengeText(task);

  if (/myth|fact|quiz/.test(text)) {
    return { pathname: "/", hash: "#myth-fact" };
  }
  if (/podcast|listen/.test(text)) {
    return { pathname: "/guides" };
  }
  if (/pro tip/.test(text) && !/short/.test(text)) {
    return { pathname: "/tips" };
  }
  if (/short/.test(text) || /tip video/.test(text)) {
    return { pathname: "/bites" };
  }
  if (/streak|daily login|\blogin\b/.test(text)) {
    return { pathname: "/rewards" };
  }
  if (/story/.test(text)) {
    return { pathname: "/tips" };
  }
  // Puzzle Mania + Aim Train live on the Play page
  if (
    task?.type === "game" ||
    /puzzle|aim train|gameplay|\baim\b/.test(text)
  ) {
    return { pathname: "/play" };
  }
  if (/news/.test(text)) {
    return { pathname: "/news" };
  }
  return { pathname: "/challenges" };
}

export function openChallenge(navigate, task) {
  const to = challengeDestination(task);
  const hash = to.hash || "";
  const here = window.location.pathname === to.pathname;

  if (here && hash) {
    document.getElementById(hash.slice(1))?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    return;
  }

  navigate(to);
}
